import { render, staticRenderFns } from "./SetGuide.vue?vue&type=template&id=18a43c7c&scoped=true"
import script from "./SetGuide.vue?vue&type=script&lang=js"
export * from "./SetGuide.vue?vue&type=script&lang=js"
import style0 from "./SetGuide.vue?vue&type=style&index=0&id=18a43c7c&prod&lang=scss&scoped=true"
import style1 from "./SetGuide.vue?vue&type=style&index=1&id=18a43c7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a43c7c",
  null
  
)

export default component.exports